import { useEffect, useState, FunctionComponent } from 'react'
import { Stack } from '@leroy-merlin-br/backyard-react'
import { datadogRum } from '@datadog/browser-rum'

import {
  GetProductVariantsData,
  getProductVariants
} from 'catalog/services/product-services'

import * as S from './styled'
import { Props } from './types'
import { Variant } from './containers'

const Variants: FunctionComponent<Props> = ({ productId }) => {
  const [variants, setVariants] = useState<GetProductVariantsData>([])

  const hasVariants = variants.length > 0

  useEffect(() => {
    const doAsync = async () => {
      try {
        const response = await getProductVariants(productId)
        setVariants(response)
      } catch (e) {
        datadogRum.addError(e)
      }
    }

    doAsync()
  }, [productId])

  if (!hasVariants) {
    return null
  }

  return (
    <S.Container>
      <Stack space="mega">
        {variants.map(variant => (
          <Variant
            variant={variant}
            productId={productId}
            key={variant.characteristicId}
          />
        ))}
      </Stack>
    </S.Container>
  )
}

export default Variants
